import { ZOptionsParser$ } from './options-parser.impl.js';
/**
 * Builds custom command line options parser.
 *
 * @typeParam TOption  A type of option representation.
 * @typeParam TCtx  A type of option processing context required by parser.
 * @param config - Parser configuration.
 *
 * @returns New options parser.
 */
export function customZOptionsParser(config) {
    const parser = new ZOptionsParser$(config);
    return parser.parseOptions.bind(parser);
}
//# sourceMappingURL=options-parser.js.map